// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OurValues_componentWrapper__zxVad"};